import { render, staticRenderFns } from "./BestaetigenDialog.vue?vue&type=template&id=a540794c&scoped=true&"
import script from "./BestaetigenDialog.vue?vue&type=script&lang=js&"
export * from "./BestaetigenDialog.vue?vue&type=script&lang=js&"
import style0 from "./BestaetigenDialog.vue?vue&type=style&index=0&id=a540794c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../home/zarzar/Documents/public-solution/bis-office/web/zeitkontrolle/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a540794c",
  null
  
)

export default component.exports